import React, { useState } from 'react';
import * as Recharts from 'recharts';

import ChartCard from '../../ChartComponents/ChartCard';
import ChartTooltip from '../../ChartComponents/ChartTooltip';
import Info from '../../../../components/Info';
import {
  axisTick,
  chartMargin,
  formatAxisTime,
  tickEvery,
} from '../chartShared';
import { GENDER_FEMALE_COLOR, GENDER_MALE_COLOR } from '../constants';
import style from '../style.module.scss';

const legendStyle = { fontSize: '14px', color: '#4E5155', textTransform: 'capitalize' };

const GenderGroupedBar = ({ data }) => {
  const [showMale, setShowMale] = useState(true);
  const [showFemale, setShowFemale] = useState(true);
  const rows = data?.genderTimeline || [];
  const every = tickEvery(rows.length);

  if (!rows.length) {
    return null;
  }

  const onLegendClick = ({ dataKey }) => {
    if (dataKey === 'male') setShowMale((v) => !v);
    if (dataKey === 'female') setShowFemale((v) => !v);
  };

  return (
    <ChartCard
      title={(
        <Info
          label="Gender"
          content="Male and female face counts per scan session"
          className="ml-2"
        />
      )}
    >
      <div className={style.chartFix}>
        <Recharts.ResponsiveContainer width="100%" height={400}>
          <Recharts.BarChart data={rows} margin={chartMargin} isAnimationActive={false}>
            <Recharts.CartesianGrid strokeDasharray="3 3" stroke="#E8E8E8" vertical={false} />
            <Recharts.XAxis
              dataKey="time"
              type="category"
              tickLine
              axisLine={{ stroke: '#B7B8BA' }}
              interval={every}
              tick={axisTick}
              tickFormatter={formatAxisTime}
            />
            <Recharts.YAxis
              tickLine
              axisLine={{ stroke: '#B7B8BA' }}
              width={52}
              tick={axisTick}
              label={{
                value: 'Face count',
                angle: -90,
                position: 'insideLeft',
                style: { fill: '#4E5155', fontSize: 12, textAnchor: 'middle' },
              }}
            />
            <Recharts.Tooltip
              content={<ChartTooltip />}
              labelFormatter={(label) => `Scan ${label}`}
              cursor={{ fill: 'rgba(78, 81, 85, 0.06)' }}
            />
            <Recharts.Legend
              verticalAlign="top"
              align="right"
              wrapperStyle={legendStyle}
              iconType="circle"
              iconSize="11"
              onClick={onLegendClick}
            />
            <Recharts.Bar
              dataKey="male"
              name="Male"
              fill={GENDER_MALE_COLOR}
              radius={[4, 4, 0, 0]}
              hide={!showMale}
            />
            <Recharts.Bar
              dataKey="female"
              name="Female"
              fill={GENDER_FEMALE_COLOR}
              radius={[4, 4, 0, 0]}
              hide={!showFemale}
            />
          </Recharts.BarChart>
        </Recharts.ResponsiveContainer>
      </div>
    </ChartCard>
  );
};

export default GenderGroupedBar;
